// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.0311 1.88843L23.688 11.5453L15.3429 19.8904L15.0735 20.1617H19.9999V22.1617L6.74802 22.1617L0.25293 15.6666L14.0311 1.88843ZM5.78846 12.9595L3.08136 15.6666L7.57645 20.1617H12.2551L12.6215 19.7925L5.78846 12.9595Z"}}]};

const ClearFormattingFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'clear-formatting-filled',
    ref,
    icon: element,
  },
));

ClearFormattingFilledIcon.displayName = 'ClearFormattingFilledIcon';

export default ClearFormattingFilledIcon;
